import { render, staticRenderFns } from "./mobile-menu-icon.vue?vue&type=template&id=b160dcfe&scoped=true&"
import script from "./mobile-menu-icon.vue?vue&type=script&lang=ts&"
export * from "./mobile-menu-icon.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-menu-icon.vue?vue&type=style&index=0&id=b160dcfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b160dcfe",
  null
  
)

export default component.exports